<template>
  <footer class="main">
    <div class="container">
      <!-- <p>到訪人數：<span>107692</span></p> -->
      <p>
        地址：30210 新竹縣竹北市光明六路10號<br />
        電話：035513520或035513522轉301~309 <br />
        辦公時間： 8:00-12:00, 13:00-17:00
      </p>
      <p>
        新竹縣政府版權所有 2020 Hsinchu County Government © All Rights Reserved
      </p>
    </div>
  </footer>
</template>

<script>
export default {}
</script>
